/**
 * Copyright (C) 2019 User X, LLC http://whoisuserx.com <info@userx.co>
 *
 * This program is the intellectual property of User X, LLC. You may
 * not redistribute and/or modify it without written consent by controlling
 * entities of User X, LLC.
 *
 * You should have received a copy of our Web Developer Agreement which
 * outlines proper use and distribution of this program. If you did not
 * please email info@userx.co to request your copy.
 */
/**
 * File created by John M. Woodcock < john@userx.co >
 * on 2/3/2026
 * for userx-support
 */

/**
 * Initialize Google Analytics
 * @param measurementId
 */
export const initGA = (measurementId) => {
    if (!measurementId) return;
    // ensure gtag exists (script from index.html loads it)
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function(){ window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', measurementId, { send_page_view: false });
};

/**
 * Track a pageview
 * @param path
 */
export const pageview = (path,title) => {
    if (!window.gtag) return;
    window.gtag('event', 'page_view', {
        page_title: title || document.title,
        page_path: path
    });
};

/**
 * Track an event
 * @param action
 * @param category
 * @param label
 * @param value
 */
export const gaEvent = ({ action, category, label, value } = {}) => {
    if (!window.gtag) return;
    window.gtag('event', action, {
        event_category: category,
        event_label: label,
        value,
    });
};